import React, { Fragment } from 'react'
import AnchorLink from 'react-anchor-link-smooth-scroll'

const IuppHeaderDisconnected = () => {
  return (
    <Fragment>
      <div className='placeholder-header' />
      <header className='iupp-header header-disconnected'>
        <nav className='menu menu-segmentation d-none'>
          <div className='container'>
            <div className='flexible-items-container'>
              <a href='#' className='flex-item mn-item mn-business' title='Ver as vantages exclusivas para o seu negócios' tabIndex={0}>para o seu negócio</a>
              <a href='/' className='flex-item mn-item mn-personal' title='Ver as vantagens exclusivas para você' tabIndex={0}>para você</a>
            </div>
          </div>
        </nav>
        <nav className='menu menu-navigation'>
          <div className='container'>
            <a href='/' title='Ir para a página inicial' className='logo-header' tabIndex={0}><span className='d-none'>iupp</span></a>
            <div className='flexible-items-container'>
              <AnchorLink href='#experiences' data-target='#experiences' className='flex-item mn-item mn-experiences' title='experiências que combinam com você.' tabIndex={0}>experiências</AnchorLink>
              <AnchorLink href='#accumulatePoints' data-target='#accumulatePoints' className='flex-item mn-item mn-accumulate-points' title='junte pontos de diferentes formas.' tabIndex={0}>junte pontos</AnchorLink>
              <AnchorLink href='#usePoint' data-target='#usePoint' className='flex-item mn-item mn-use-points' title='use pontos do jeito que quiser.' tabIndex={0}>use pontos</AnchorLink>
              <AnchorLink href='#benefits' data-target='#benefits' className='flex-item mn-item mn-benefits' title='descontos em muitas lojas, de muitos tipos.' tabIndex={0}>descontos</AnchorLink>
              <a href='/auth/login' className='flex-item mn-item mn-login' title='Ir para área de login' tabIndex={0}>entrar</a>
              <a href='/auth/login' className='flex-item mn-item mn-register' title='Fazer cadastro' tabIndex={0}>cadastre-se</a>
            </div>
          </div>
        </nav>
      </header>
    </Fragment>
  )
}

export default IuppHeaderDisconnected



// WEBPACK FOOTER //
// ./src/App/Header/IuppHeaderDisconnected.js